// extracted by mini-css-extract-plugin
export default {"wrapper":"SaveFormPopup_wrapper__vYlVf","decoration":"SaveFormPopup_decoration__lGczm"};